import { useState, useEffect } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { TabBox, ActionLink } from 'app/_shared'

import * as service from '../../service'

import ResetEmail from './Email'
import ResetCode from './Code'
import ResetPassword from './Password'
import ResetComplete from './Complete'
import styles from '../UserContext.module.scss'

const resetSteps = ['EMAIL', 'CODE', 'PASSWORD', 'COMPLETE'];

// TODO: this can just go in the service.
const getSubmitValues = (activeStep, { email, code, password, isActivation }) => {
  let submitValues = { email, isActivation };
  resetSteps.indexOf(activeStep) >= resetSteps.indexOf('CODE') && (submitValues = { ...submitValues, code });
  resetSteps.indexOf(activeStep) >= resetSteps.indexOf('PASSWORD') && (submitValues = { ...submitValues, password });
  return submitValues;
}

const getValidationSchema = (activeStep) => {
  let schema = {
    email: Yup.string().email('Invalid').required('Required')
  };
  resetSteps.indexOf(activeStep) >= resetSteps.indexOf('CODE') && (schema = {
    ...schema,
    code: Yup.string().required('Required'),
  });
  resetSteps.indexOf(activeStep) >= resetSteps.indexOf('PASSWORD') && (schema = {
    ...schema,
    password: Yup.string().required('Required').min(6, 'Must be at least 6 characters'),
    confirmPassword: Yup.string().required('Must match above').oneOf([Yup.ref('password')], 'Must match above')
  });

  return Yup.object().shape(schema);
}

export default ({ openSignIn, finish, activeUser, mode, email, closeInvalidTab }) => {
  const [activeStep, setActiveStep] = useState('EMAIL');
  useEffect(() => {
    !!activeUser && activeStep !== 'COMPLETE' && closeInvalidTab();
  }, [!!activeUser, activeStep, closeInvalidTab]);

  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <h1>{email ? 'Activate your account' : 'Reset your password'}</h1>
        <div className={styles.subtext}>
        {!activeUser && !email && (
          <ActionLink appearance="arrow" onClick={openSignIn}>
            Back to sign in
          </ActionLink>
        )}
        </div>
      </div>
      <Formik
        initialValues={{ email: email ?? '', code: '', password: '', confirmPassword: '', isActivation: !!email }}
        validationSchema={getValidationSchema(activeStep)}
        onSubmit={async (values, actions) => {
          try {
            actions.setStatus({ error: undefined });
            await service.reset(getSubmitValues(activeStep, values));
            setActiveStep(resetSteps[resetSteps.indexOf(activeStep) + 1]);
          }
          catch({ fieldErrors, statusError, message }) {
            actions.setSubmitting(false);
            fieldErrors && actions.setErrors(fieldErrors);
            (statusError || message) && actions.setStatus({ error: statusError || message });
          }
        }}
      >
        {({values}) => (
          <TabBox activeTab={activeStep} center>
            <ResetEmail tabkey="EMAIL" editable={!!email}>
              {email ? (
                <p><b>Welcome to Realvision!</b> To activate your account, click below and we'll email you a verification code.</p>
              ) : (
                <p>Enter your email address, and we'll send you a verification code for resetting your password.</p>
              )}
            </ResetEmail>
            <ResetCode tabkey="CODE">
              <p>We've sent a code to <em>{values.email}</em>. Please enter the code here.</p>
            </ResetCode>
            <ResetPassword tabkey="PASSWORD">
              <p>Please enter and confirm a password for your account.</p>
            </ResetPassword>
            <ResetComplete tabkey="COMPLETE" finish={finish} mode={mode}>
              <p>Your password has been successfully {email ? 'set' : 'reset'}, and you are now signed in as <em>{activeUser?.email}</em>.</p>
            </ResetComplete>
          </TabBox>
        )}
      </Formik>
    </div>
  )
}
